<template>
  <div class="col-auto col-width-standard border-right">
    <div class="w-100 h-25 text-center">
      <strong>Engagement Scale</strong>
    </div>
    
    <div v-if="engagement.uwesChart" class="d-flex h-75">
      <div class="overview-chart-fixed-width align-self-center">
        <doughnutChart
          :chart-data="engagement.uwesChart"
          :options="engagement.chartOptions"
          :textMiddle="engagement.uwes.engagementScaleAverage"
        ></doughnutChart>
      </div>
      <div class="overview-info-fixed-width pl-3 align-self-center">
        <div class="row flex-nowrap justify-content-between">
          <div class="col">Vigor:</div>
          <div class="col text-right">
            {{ engagement.uwes.engagementSubscale.vigorPercentage }}%
          </div>
        </div>
        <div class="row justify-content-between">
          <div class="col">Dedication:</div>
          <div class="col text-right">
            {{ engagement.uwes.engagementSubscale.dedicationPercentage }}%
          </div>
        </div>

        <div class="row flex-nowrap justify-content-between">
          <div class="col">Absorption:</div>
          <div class="col text-right">
            {{ engagement.uwes.engagementSubscale.absorptionPercentage }}%
          </div>
        </div>
      </div>
    </div>
    <div v-else class="d-flex h-75">
      <div class="m-auto">
        <p>Uwes hasn't been filled in yet. Employees can find this on their details page</p>
      </div>
    </div>
  </div>
</template>

<script>
import doughnutChart from "@/components/engagement/charts/percentageDoughnutChart.js";
import { Doughnut, mixins } from "vue-chartjs";
import { engagementScaleMethods } from "@/mixins/engagement/engagementScaleMethods.js";

export default {
  extends: Doughnut,
  mixins: [mixins.reactiveProp, engagementScaleMethods],
  props: ["engagement", "chartData"],
  components: {
    doughnutChart,
  },
  computed: {},
  mounted() {},
  methods: {},
  watch: {
    engagement: function (newVal, oldVal) {
      this.engagement.uwes = newVal.uwes;
      console.log("Prop changed:", newVal, " | was: ", oldVal);
    },
  },
  created() {},
};
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/engagement/_EmployeeOverviewBar.scss";
</style>